import { EventEmitter } from "events";
import dispatcher from "../dispatchers/dispatcher";

class FeedbackSurveyStores extends EventEmitter {
    constructor() {
        super();
        this.initData();
    }
    initData() {
        this.eventType = "";
        this.feedbackSurveyData = [];
    }

    _checkSurveyConfigData(type, onlyFetch) {
        /**
         * onlyFetch - this argument is only used to fetch the info whether we need to show popup or not
         */
        this.eventType = type;
        this.emit("change", "CHECK_SURVEY_CONFIG_DATA", onlyFetch);
    }
    
    _getEventName() {
        const type = this.eventType.split("GET_NPS_SURVEY_")[1];
        const eventNameMap = {
            "REPORT_SUBMITTED": "REPORT_SUBMISSION",
            "REPORT_APPROVED": "REPORT_APPROVAL",
        };
        return eventNameMap[type];
    }

    _setFeedbackSurveyData(data, onlyFetch) {
        this.feedbackSurveyData = data;
        if (!onlyFetch)
            this.emit("change", "GET_FEEDBACK_SURVEY_DATA");
    }

    _getFeedbackSurveyData() {
        return this.feedbackSurveyData;
    }
    
    _handleActions(action) {
        switch (action.type) {
            // add multiple Trigger case
            case "GET_NPS_SURVEY_REPORT_SUBMITTED":
            {
                this._checkSurveyConfigData(action.type);
                break;
            }
            case "GET_FEEDBACK_SURVEY_DATA": {
                this._setFeedbackSurveyData(action.response, action.onlyFetch);
                break;
            }
            case "GET_FEEDBACK_SURVEY_DATA_NOW": {
                this.emit("change", "GET_FEEDBACK_SURVEY_DATA");
                break;
            }
            case "SUBMIT_FEEDBACK_SURVEY": {
                this.emit("change", "SUBMIT_FEEDBACK_SURVEY");
                this.initData();
                break;
            }
            default:
                // Nothing to in default
        }
    }
}

const feedbackSurveyStores = new FeedbackSurveyStores();
if (process.env.NODE_ENV !== "production") window.surveyStores = feedbackSurveyStores;
dispatcher.register(feedbackSurveyStores._handleActions.bind(feedbackSurveyStores));
export default feedbackSurveyStores;
